import script from "./ReferAFriendLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferAFriendLayout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__